import * as context from '@adsk/alloy-react-context';
import deprecate from './deprecate';
import useDeprecate from './hooks/useDeprecate';

/**
 * @deprecated Please update to import from @adsk/alloy-react-context
 */
export const getOrCreateGlobalContext = function () {
  deprecate('@adsk/alloy-react-helpers', 'getOrCreateGlobalContext', 'Please update to import from @adsk/alloy-react-context');
  return context.getOrCreateGlobalContext(...arguments);
};

/**
 * @deprecated Please update to import from @adsk/alloy-react-context
 */
export const getGlobalContext = function () {
  deprecate('@adsk/alloy-react-helpers', 'getGlobalContext', 'Please update to import from @adsk/alloy-react-context');
  return context.getGlobalContext(...arguments);
};

/**
 * @deprecated Please update to import from @adsk/alloy-react-context
 */
export const useContextWithValidation = function () {
  useDeprecate(true, '@adsk/alloy-react-helpers', 'useContextWithValidation', 'Please update to import from @adsk/alloy-react-context');
  return context.useContextWithValidation(...arguments);
};

/**
 * @deprecated Please update to import from @adsk/alloy-react-context
 */
export const CONTEXT_NAMES = context.CONTEXT_NAMES;
//# sourceMappingURL=deprecatedContext.js.map